// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__WDbYb","topBottomGutter":"Layout_topBottomGutter__1pOc_"};